var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"header"}},[_c('HeaderTop',{attrs:{"msg":_vm.boasVindas}}),_c('div',{attrs:{"id":"headerContainer"}},[_c('LogoArea'),_c('SearchArea'),_c('CartArea')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }